import Api from '@/services/Api'

export default {
  
  getOrder(orderId) {
    return Api().get(`order/${encodeURIComponent(orderId)}`);
  },

  getMongoOrder(orderId) {
    return Api().get(`mongo/order/${encodeURIComponent(orderId)}`);
  },

  getMilestones(orderId){
    return Api().get(`support/milestones/${encodeURIComponent(orderId)}`);
  },

  getTrackingState(plentyOrder) {
    return Api().post("trackingState", plentyOrder);
  },

  loadTickets() {
    return Api().get("tickets");
  },

  loadTicket(ticketId) {
    return Api().get(`ticket/${ticketId}`);
  },

  closeTicket(ticketId) {
    return Api().post(`ticket/${ticketId}/close`);
  },
  

  replyToTicket(ticketId, message, attachments) {
    return Api().post(`ticket/${ticketId}/reply`, { message: message, attachments: attachments });
  },

  cancelOrder(orderId) {
    return Api().post(`cancelOrder/${orderId}`);
  },

  setPacked(orderId) {
    return Api().post(`support/order/${encodeURIComponent(orderId)}/packed`);
  },

  // Cross system state of one order: ERP, packlist, multicart shelf, lifecycle
  // and the problems plaster detects. No carrier call, see PlasterController.
  getPlaster(orderId) {
    return Api().get(`support/plaster/${encodeURIComponent(orderId)}`);
  },

}